<script setup lang="ts">
import { computed } from 'vue'
import { RouterView } from 'vue-router'
import AppHeader from './components/AppHeader.vue'
import CrtOverlay from './components/CrtOverlay.vue'
import Scanlines from './components/Scanlines.vue'
import { usePreferencesStore } from './stores/preferences'
import { useAchievementsStore } from './stores/achievements'
import AchievementToast from './components/AchievementToast.vue'

const ach = useAchievementsStore()
void ach

const p = usePreferencesStore()
const shellClasses = computed(() => [
  'app-shell',
  `theme-${p.prefs.theme}`,
  { 'crt-on': p.prefs.crtEnabled, 'reduce-motion': p.prefs.reduceMotion },
])
</script>

<template>
  <div :class="shellClasses">
    <CrtOverlay />
    <Scanlines v-if="p.prefs.crtEnabled" />
    <div class="app-content">
      <AppHeader />
      <main class="app-main">
        <RouterView />
      </main>
      <footer class="app-footer">
        <p class="pixel-font">
          <span class="blink">●</span> Retro Arcade · Built with Vue 3 + Phaser.js
        </p>
      </footer>
    </div>
  </div>
  <AchievementToast />
</template>

<style scoped>
.app-shell {
  min-height: 100vh;
  background: var(--ra-bg-900);
  color: var(--ra-fg);
  position: relative;
  overflow-x: hidden;
}
.app-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.app-main {
  flex: 1;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 24px 24px 40px;
}
.app-footer {
  text-align: center;
  padding: 20px;
  color: var(--ra-fg-muted);
  font-size: 10px;
  letter-spacing: 1px;
}
.blink { color: var(--ra-neon-pink); animation: blink 1s step-end infinite; }
@keyframes blink { 0%, 50% { opacity: 1; }  51%, 100% { opacity: 0; } }
</style>
